module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "dropdown",
    staticClass: "btn-group",
    class: {
      'open': _vm.open
    },
    on: {
      "mouseover": _vm.mouseOver,
      "mouseout": _vm.mouseOut,
      "click": _vm.toggle
    }
  }, [_c('button', {
    class: _vm.btnClass,
    on: {
      "blur": _vm.loseFocus
    }
  }, [_vm._v("\n\t\t" + _vm._s(_vm.name) + "\n\t\t"), _c('span', {
    staticClass: "caret"
  })]), _vm._v(" "), _vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-e9648fa2"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/common/widget/NbBtnDropdown.vue
// module id = 1032
// module chunks = 1